export var truncateText = function (text, maxLength) {
    if ((text === null || text === void 0 ? void 0 : text.length) <= maxLength)
        return text;
    return (text === null || text === void 0 ? void 0 : text.slice(0, maxLength)) + '...';
};
